module.exports = __webpack_public_path__ + "1073fe3b049addd142de98c9b252751b.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1144
// module chunks = 0